export function isSelector(x) {
    return typeof x === 'string' && x.length > 1;
}
export function ensureAllElements(selectorElement, context = document) {
    if (isSelector(selectorElement)) {
        return Array.from(context.querySelectorAll(selectorElement));
    }
    if (selectorElement instanceof NodeList) {
        return Array.from(selectorElement);
    }
    if (Array.isArray(selectorElement)) {
        return selectorElement;
    }
    throw new Error(`Unknown selector element`);
}
export function ensureElement(selectorElement, context) {
    if (isSelector(selectorElement)) {
        const elements = ensureAllElements(selectorElement, context);
        if (elements.length > 1) {
            console.warn(`selector ${selectorElement} return more then one element`);
        }
        if (elements.length === 0) {
            throw new Error(`selector ${selectorElement} return nothing`);
        }
        return elements.pop();
    }
    if (selectorElement instanceof HTMLElement) {
        return selectorElement;
    }
    throw new Error('Unknown selector element');
}
export function cloneTemplate(query) {
    const template = ensureElement(query);
    return template.content.firstElementChild.cloneNode(true);
}
export function handlePrice(price) {
    const priceStr = price.toString();
    return priceStr.length < 5
        ? priceStr
        : priceStr
            .split('')
            .reverse()
            .map((s, i) => ((i + 1) % 3 === 0 ? ' ' + s : s))
            .reverse()
            .join('');
}
